import moment from 'moment';
import { DoctorService } from '@/services/doctor.service.js';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      }
    },
    mode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDialog: false,
      buttonDisabled: false,
      alert: {
        show: false,
        message: ''
      }
    };
  },
  methods: {
    getDateTime(date) {
      return moment(date * 1000).format('MM/DD/YYYY LTS');
    },
    async removeEntry() {
      if (this.buttonDisabled) {
        return;
      }
      this.buttonDisabled = true;
      try {
        if (this.mode == 'cancel') {
          const {
            data
          } = await DoctorService.cancelReassignment(this.rowData.id);
          if (data) {
            this.$emit('show-toast', 'Reassignment cancelled successfully!');
            this.$emit('refresh');
            this.showDialog = false;
          }
        } else if (this.mode == 'deny') {
          const {
            data
          } = await DoctorService.deleteReassignment(this.rowData.id);
          if (data) {
            this.$emit('show-toast', 'Reassignment denied successfully!');
            this.$emit('refresh');
            this.showDialog = false;
          }
        }
      } catch (e) {
        this.alert = {
          show: true,
          message: e.message
        };
      } finally {
        this.buttonDisabled = false;
      }
    },
    onHide() {
      this.alert = {
        show: false,
        message: ''
      };
      this.buttonDisabled = false;
    }
  }
};